import React from 'react';

import { connect } from 'react-redux';
import { BaseStore } from 'src/store';
import { LayoutPageHeading, LayoutBlockTextImage } from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { EventsStore } from '../../store/types';
import { useIntl } from 'react-intl';
import moment from 'moment';
import 'moment/locale/de';
import { useLocale } from 'src/modules/locale';
import styles from './EventsPage.module.scss';

interface EventsPageProps extends EventsStore {}

const EventsPage: React.FunctionComponent<EventsPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject, locale } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/events/head/page_title' }),
    description: intl.formatMessage({ id: 'page/events/head/meta_description' }),

    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals',
        }),
        as: '/professionals',
        href: '/professionals',
      },
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/professionals/events',
        }),
        as: '/professionals/events',
        href: '/professionals/events',
      },
    ],
  };

  const { events } = getLocalizedObject(props);

  moment.locale(locale);
  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading
        titleKey="page/events/title"
        sublineKey={events.length ? 'page/events/subline' : 'page/events/subline_noevents'}
      />

      <div className={styles.events}>
        {events.map(({ name, description, image, start_date, end_date, button }, idx) => (
          <LayoutBlockTextImage
            // even={false}
            // stretch={true}
            key={idx}
            title={name}
            button={button}
            subline={
              <div>
                <p>
                  {moment(start_date).format('DD MMMM')} - {moment(end_date).format('DD MMMM YYYY')}
                </p>
                <div dangerouslySetInnerHTML={{ __html: description }} />
              </div>
            }
            image={image}
          />
        ))}
      </div>
    </LayoutPage>
  );
};

const mapStateToProps = (state: BaseStore) => {
  return { ...state.events };
};

export default connect(mapStateToProps)(EventsPage);
